import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import {deleteInv} from "../../../../../api/inventory/InvApi";
import useGoToNavigation from "../../../../../util/useGotoNavigation";


export const useDeleteInv = () => {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: { inventoryIdList: number[], }) => deleteInv(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "삭제되었습니다",
                type: "alert",
                closeAction: () => {
                    qc.invalidateQueries({queryKey: ["readInv"]})
                    goToNavigation(`inventory/inv/list`, {}, false)
                }
            });
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
